enum UserFormSteps {
    info,
    review,
}

export default UserFormSteps;
